// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ProductHierarchyLevel = t.declare('ProductHierarchyLevel');

ProductHierarchyLevel.define(t.struct({
    code: t.String,
    description: t.String,
    level: t.Integer,
    parentCode: t.String,
    productHierarchy: t.maybe(t.list(ProductHierarchyLevel))
}));

export const getDefaultState = () => new ProductHierarchyLevel({
    code: '',
    description: '',
    level: 0,
    parentCode: '',
    productHierarchy: []
});

export default ProductHierarchyLevel;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/product-hierarchy-level.js